type Context = 'track' | 'search' | 'savedSearches' | 'unsubscribe' | 'send-to-pure' | 'user' | 'usersRoles';

export const getDefaultAlertOptions = (context: Context, message: string, type = 'warning') => ({
  type,
  context,
  content: <div>{message}</div>,
});
